import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Download-2" }), /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Download-2",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle",
					fillRule: "nonzero",
					x: 0,
					y: 0,
					width: 24,
					height: 24
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 12,
					y1: 14,
					x2: 12,
					y2: 20,
					id: "Path",
					stroke: "#0C0310",
					strokeWidth: 2,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15,19 L12.7071,21.2929 C12.3166,21.6834 11.6834,21.6834 11.2929,21.2929 L9,19",
					id: "Path",
					stroke: "#0C0310",
					strokeWidth: 2,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9495,16 C20.5978,15.3647 21,14.4793 21,13.5 C21,11.567 19.433,10 17.5,10 C17.3078,10 17.1192,10.0155 16.9354,10.0453 C16.4698,6.63095 13.5422,4 10,4 C6.13401,4 3,7.13401 3,11 C3,12.9587 3.80447,14.7295 5.10102,16",
					id: "Path",
					stroke: "#0C0310",
					strokeWidth: 2,
					strokeLinecap: "round"
				})
			]
		})
	})]
});
export default SvgDownload;
